import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 231px;

  button {
    border: solid 1px ${props => props.theme.color.monochrome.light};
    color: ${props => props.theme.color.monochrome.darker};
    font-size: 12px;
    font-weight: 400;
    padding: 6px 10px 8px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    height: 30px;

    &:hover,
    &:active {
      border-color: ${props => props.theme.color.monochrome.dark};
      color: ${props => props.theme.color.monochrome.darker};
    }
  }
`
const ReportButtonContainer = styled.div`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].xs}) {
    flex: auto;
    display: flex;
    flex-direction: row-reverse;
    button {
      margin-right: 0px;
    }
  }
`

const ReportContents = styled.span`
  &&& {
    display: flex;
  }
  svg {
    top: 0px;
    margin-right: 0px;
  }
`

const ReportButtonText = styled.span`
  margin-left: 5px;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].xs}) {
    display: none;
  }
`

const Grateful = styled.p`
  color: #008542;
  background-color: ${props => props.theme.color.palette['brand-1-light']};
  padding: 0px 10px 0px 10px;
  margin: 0px 10px 10px 0px;
  font-size: 12px;
  border-radius: 3px;
  &&& {
    font-weight: 600;
    line-height: 1.8rem;
  }
`

export { Container, Grateful, ReportContents, ReportButtonText, ReportButtonContainer }
